import React from 'react';
import { CategoryShowcase } from '../../../../components/CategoryShowcase';
import { Box, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useBottomCategoryShowcaseController } from './BottomCategoryShowcase.controller';
import { withLazyPropOnIntersection } from '@shared/utils/hooks/useLazyLoadImage';
import { useTranslation } from '@shared/core';
import { SkeletonGroup, SkeletonText } from '@shared/components/Skeleton';
import { styles } from './BottomCategoryShowcase.styles';

export const Root = React.forwardRef<HTMLDivElement, { isOnScreen: boolean }>((props, ref) => {
  const { isOnScreen } = props;
  const { onBrowseClick, selectedCategory, bottomCategoryShowcaseList, isLoading, parentTitle } = useBottomCategoryShowcaseController(isOnScreen);

  const { t } = useTranslation('catalogRegistry');
  const { exploreMore } = t('productGrid');

  return bottomCategoryShowcaseList.length > 1 ? (
    <Box
      __css={styles.root}
      marginBottom={pxToRem(128)}
      marginTop={7}
    >
      <Box
        ref={ref}
        width="100%"
      >
        <SkeletonGroup
          isReady={!isLoading && isOnScreen}
          placeholder={
            <SkeletonText
              rows={1}
              skeletonHeight={8}
              width={pxToRem(300)}
            />
          }
          marginX={{ _: 6, md3: 8 }}
          marginBottom={6}
        >
          <TextV2
            fontSize={{ _: 20, sm2: 32 }}
            fontWeight={600}
            marginBottom={6}
          >
            {exploreMore({ parentTitle })}
          </TextV2>
        </SkeletonGroup>
      </Box>
      <Box
        __css={styles.showcaseContainer}
        marginTop={0}
      >
        <CategoryShowcase
          categories={bottomCategoryShowcaseList}
          showSkeleton={isLoading || !isOnScreen}
          key={selectedCategory?.id}
          onBrowseCategoryClick={onBrowseClick}
        />
      </Box>
    </Box>
  ) : null;
});

const LazyLoadingCategoryRecommendationsCarousel = withLazyPropOnIntersection(Root, 'isOnScreen');

export const BottomCategoryShowcase: React.FC = () => {
  return <LazyLoadingCategoryRecommendationsCarousel isOnScreen={{ onscreen: true, offscreen: false }} />;
};
